import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import attendantServiceUnitReadAction from './attendantServiceUnitRead.action.json' with { type: 'json' }

const attendantServiceUnitReadDefinition = defineReadAutoAction(
  attendantServiceUnitReadAction,
  'attendantServiceUnit',
)

export default attendantServiceUnitReadDefinition
